import application from 'application/application';

import moment from 'moment';

const controller = 'TermsConditionsController';

application.controller(controller, [
	'$scope',
	'$http',
	'$state',
	'helper',
	'API',
	'$stateParams',
	($scope, $http, $state, helper, API, $stateParams) => {
		$scope.loadingTerms = false;

		$scope.termsUse = [];

		$scope.getTerms = () => {
			let payload = $stateParams.version;
			let api = !payload ? API.termsUse : API.termsUseVersion;

			$http({
				...helper.http(api, 'GET', {
					Id: payload
				})
			}).then(({ data }) => {
				const iframe = document.getElementById('iframeContent');

				$scope.loadingTerms = true;

				iframe.innerHTML = data.itens[0].textoTermo;

				$scope.termsUse = data.itens[0];

				$scope.termsUse = data.itens[0];

				const element = document.getElementById('dateUpdate');

				$scope.date = moment(
					new Date($scope.termsUse.dataHoraPublicacaoTermo)
				).format('DD/MM/YYYY');

				element.innerHTML = `Data de publicação: ${$scope.date}`;

				$('.oldTerms') &&
					$('.oldTerms').each(function(index, element) {
						$scope.getOldTermsUrl(index + 1, element);
					});
			});
		};

		$scope.getOldTermsUrl = (version, element) => {
			let url = location.origin + `/termos-e-condicoes/${version}`;
			let newUrl = url;

			element.setAttribute('href', newUrl);
		};

		$scope.getTerms();
	}
]);

export default controller;
